import { useEffect, useState } from "react";
import { api, formatINR } from "@/lib/api";

export default function AdminPlans() {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(null);

  useEffect(() => {
    api.get("/admin/ai-plans").then((r) => setPlans(r.data)).catch(() => setPlans([])).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="admin-plans">
      <div className="overline">Console · AI Plans</div>
      <h1 className="mt-2 font-display text-3xl lg:text-4xl tracking-tighter">AI Plans generated · {plans.length}</h1>
      <p className="mt-1 text-neutral-400 text-sm">Every plan generated by the public AI planner.</p>

      {loading ? (
        <div className="mt-8 text-neutral-500">Loading…</div>
      ) : plans.length === 0 ? (
        <div className="mt-8 surface p-10 text-center text-neutral-500">No plans yet. Generate one from the public AI Planner.</div>
      ) : (
        <div className="mt-8 space-y-3">
          {plans.map((p) => (
            <div key={p.id} className="surface p-5" data-testid={`plan-${p.id}`}>
              <button
                onClick={() => setOpen(open === p.id ? null : p.id)}
                className="w-full text-left flex items-center justify-between gap-4"
              >
                <div>
                  <div className="font-display text-lg">{p.plan?.headline || "Unnamed plan"}</div>
                  <div className="text-xs text-neutral-500 mt-1">
                    {p.request?.industry} · {p.request?.objective} · {formatINR(p.request?.budget_inr || 0)} · {p.request?.duration_weeks}w · {p.model}
                  </div>
                </div>
                <div className="text-xs text-amber-500">{new Date(p.created_at).toLocaleDateString()}</div>
              </button>
              {open === p.id && (
                <pre className="mt-4 text-xs text-neutral-300 bg-black/50 p-4 overflow-auto max-h-96 font-mono">
{JSON.stringify(p.plan, null, 2)}
                </pre>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
